export interface ProductCategory {
    ClientKey?: string;
    Id: string;
    ProductCategoryName: string; 
}

